
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"125","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2214"}},[_c('path',{attrs:{"data-name":"Rectangle 2936","fill":"none","d":"M0 0h124.999v120H0z"}}),_c('path',{attrs:{"data-name":"Path 1344","d":"M124.999 60.39L86.055 21.446A3.973 3.973 0 0082.999 20h-20a4.276 4.276 0 00.5 8.5l15.5 14.942-16.3 6.077-22.73-22.73a3.971 3.971 0 00-3.054-1.445h-20a4.276 4.276 0 00.5 8.5H23v30.637a17.959 17.959 0 00-8.463 30.486l25.034 25.034h85.431z","fill":"#ec4618"}}),_c('path',{attrs:{"data-name":"Path 1345","d":"M86.999 64.481V24a4 4 0 00-4-4h-20a4 4 0 000 8h16v15.442l-48 17.894V33.344h5.915a4 4 0 000-8h-20a4 4 0 000 8h6.085v31.137a18.032 18.032 0 1014.516 2.965l41.484-15.469v12.5a18 18 0 108 0zM26.999 92a10 10 0 1110-10 10.009 10.009 0 01-10 10zm56 0a10 10 0 1110-10 10.009 10.009 0 01-10 10z","fill":"#f9a36c"}})])])
          )
        }
      }
    